export const ds = {
  // Bordes metálicos
  metalBorder: '0.5px solid rgba(160,160,175,0.25)',
  metalBg: 'linear-gradient(145deg, rgba(180,180,190,0.08), rgba(120,120,135,0.04))',
  metalHoverBorder: '0.5px solid rgba(160,160,175,0.45)',
  metalHoverBg: 'linear-gradient(145deg, rgba(180,180,190,0.15), rgba(120,120,135,0.08))',

  // Colores de acento (usados en hover y estados)
  accent: {
    primary: '#E62117',   // Rojo marca — tabs activos, CTAs principales
    blue: '#3b82f6',      // Info, mecánicos, confirmaciones
    amber: '#d97706',     // Advertencias, citas pendientes, alertas próximas
    green: '#10b981',     // Éxito, verificado, completado, dinero
    purple: '#8b5cf6',    // Reviews, enviados, diagnósticos
    rose: '#E62117',      // Notificaciones, badges de conteo
  },

  // Helpers para generar fondo sutil de un color
  accentBg: (color) => `${color}0d`,       // 5% opacity
  accentBorder: (color) => `${color}30`,   // 19% opacity
  accentHoverBg: (color) => `${color}12`,  // 7% opacity

  // Radios
  radius: { sm: '3px', md: '4px', lg: '6px', xl: '8px', pill: '999px' },

  // Sombras sutiles (solo para cards principales)
  shadow: { sm: '0 1px 2px rgba(15,23,42,0.04)', md: '0 4px 20px rgba(15,23,42,0.05)' },

  // Paleta neutral dark — sin cast azul
  // Usar estas en vez de los colores Tailwind slate (#0F172A, #1E293B, #1F2937, #111827)
  dark: {
    bg: '#101416',      // fondo de página
    card: '#1C2023',    // cards y paneles
    elevated: '#272A2D', // elementos elevados (inputs, sub-cards)
    border: '#2F3237',  // bordes fuertes (no metálicos)
    text: '#E0E3E6',    // texto principal
    sub: '#94979A',     // texto secundario
  },

  // Tipografía
  font: {
    head: "'Sora', system-ui, sans-serif",
    body: "'Inter', system-ui, sans-serif",
    mono: "'JetBrains Mono', ui-monospace, monospace",
  },

  // Breakpoints desktop (en px, usar con matchMedia / window.innerWidth)
  bp: {
    sm: 640,    // teléfonos en horizontal
    md: 1024,   // tablet / laptop pequeña — umbral desktop
    lg: 1280,   // desktop estándar
    xl: 1536,   // pantallas grandes
  },

  // Sidebar desktop (usado por AuthDesktopLayout + Sidebar)
  sidebar: {
    width: 280,
    bg: '#181C1E',
    bgHover: '#272A2D',
    borderInner: '#2F3237',
    text: '#E0E3E6',
    textActive: '#FFFFFF',
    textMuted: '#94979A',
    activeBg: 'rgba(230,33,23,0.20)',
    activeBar: '#E62117',
  },
};
